<script>
  /* Executable code section of the program */
  //Tools importation
  import { temporalChatAttendee, isEmptyChatBox,isOpenChat,userLocalData,dinamicChat } from "../../apis/storage";

  //Auxiliary variables
  export let chat;
  $: dinamicStatus = chat.status
  /* 
  $dinamicChat = chat.chatId.split("-").includes($userLocalData[0].id) */
  let windowSize =  window.innerWidth;

  //Function to display chat
  const displayChat = () =>{
    $isEmptyChatBox = true
    $temporalChatAttendee = chat
    chat.status = "read";
    localStorage.setItem(`lastMessage-${chat.chatId}`,Date.now())
    console.log(chat);
    
    
    if (windowSize < 701) {
      $isOpenChat = true
    }
  }
  
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
 {#if dinamicStatus === "unread"}
 {#if chat.chatId.split("-").includes($userLocalData[0].id)}
 <div class="cardContainerUnread" on:click={displayChat} on:keypress={displayChat}>
   <div class="imgContainer">
     {#if chat.profileImgUrl === "" || chat.profileImgUrl === undefined}
       <div class="circle">
         <h4>{chat.name.slice(0, 1)}{chat.surname.slice(0, 1)}</h4>
       </div>
     {:else}
       <img class="imgAvatar" src={chat.profileImgUrl} alt="Avatar Profile" />
     {/if}
   </div>
   <div class="chatInformation">
     <div class="headerInfo">
       <p class="text">
        <b>
          {chat.name}
          {chat.surname}
        </b> <br />
         {chat.jobtittle} <br />
         {chat.company} <br />
         {chat.country}
       </p>
     </div>
   </div>
 </div>
  {:else}
  <div class="cardContainer" on:click={displayChat} on:keypress={displayChat}>
    <div class="imgContainer">
        <img class="imgPoster" src={chat.eventPoster} alt="Avatar Profile" />
    </div>
    <div class="chatInformation">
      <div class="headerInfo">
        <p class="text">
          <b>{chat.eventTittle}</b>
           <br />
          {chat.eventCountry} <br />
        </p>
      </div>
    </div>
  </div>
 {/if}
  {:else}
  {#if chat.chatId.split("-").includes($userLocalData[0].id)}
  <div class="cardContainer" on:click={displayChat} on:keypress={displayChat}>
    <div class="imgContainer">
      {#if chat.profileImgUrl === "" || chat.profileImgUrl === undefined}
        <div class="circle">
          <h4>{chat.name.slice(0, 1)}{chat.surname.slice(0, 1)}</h4>
        </div>
      {:else}
        <img class="imgAvatar" src={chat.profileImgUrl} alt="Avatar Profile" />
      {/if}
    </div>
    <div class="chatInformation">
      <div class="headerInfo">
        <p class="text">
         <b>
           {chat.name}
           {chat.surname}
         </b> <br />
          {chat.jobtittle} <br />
          {chat.company} <br />
          {chat.country}
        </p>
      </div>
    </div>
  </div>
   {:else}
   <div class="cardContainer" on:click={displayChat} on:keypress={displayChat}>
     <div class="imgContainer">
         <img class="imgPoster" src={chat.eventPoster} alt="Avatar Profile" />
     </div>
     <div class="chatInformation">
       <div class="headerInfo">
         <p class="text">
           <b>{chat.eventTittle}</b>
            <br />
           {chat.eventCountry} <br />
         </p>
       </div>
     </div>
   </div>
  {/if}
 {/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Container styles */
  .cardContainer {
    width: 100%;
    height: 120px;
    display: flex;
    margin: 5px 0;
  }
  .cardContainer:hover {
    cursor: pointer;
    background-color: #ebebeb;
  }
  .cardContainerUnread{
    width: 100%;
    height: 120px;
    display: flex;
    margin: 5px 0;
    background-color: #004182be;
  }
  .cardContainerUnread:hover{
    cursor: pointer;
    background-color: #c3ddf8

  }
  /* Card content styles */
  /* Avatar styels */
  .imgContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    height: 100%;
  }
  .circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #ed2824;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .imgAvatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .imgPoster{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  /* Information styles */
  .chatInformation {
    padding: 10px;
    width: 70%;
    height: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid gray;
  }
  .headerInfo {
    display: flex;
    justify-content: space-between;
  }
  .text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  }

  /* End of the section */
</style>
